<template>
  <div class="tutors-list">
    <TutorCard v-for="tutor in tutors" :key="tutor.id" :tutor="tutor" />
  </div>
</template>

<script>
import TutorCard from "./TutorCard.vue";

export default {
  name: "TutorsList",
  components: { TutorCard },
  props: ["tutors"],
};
</script>

<style lang="scss" scoped>
.tutors-list {
  display: grid;
  max-width: calc($max-xl-screen - 324px);
  grid-template-columns: repeat(auto-fit, 237px);
  gap: 14px;
}

@media all and (min-width: $min-md-screen) and (max-width: $max-lg-screen) {
  .tutors-list {
    max-width: calc($max-lg-screen - 162px);
    column-gap: 14px;
    row-gap: 8px;
  }
}

@media all and (max-width: $min-md-screen) {
  .tutors-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 8px;
  }
}
</style>
